import { getAccessCode, getFallbackUrl, getRedirectUrl } from "@/lib/utils";
import { ErrorCodeType } from "@/types";
import { Dispatch, useCallback, useState } from "react";
import { useFailure } from "./useFailure";

const useOneTimeLogin = () => {
  const [errorCode, setErrorCode] = useState<ErrorCodeType | undefined>(undefined);
  const { handleRedirectFailure } = useFailure();

  const signInOtp = useCallback(
    (otp: string, setButtonLoading: Dispatch<React.SetStateAction<boolean>>) => {
      setButtonLoading(true);
      nest.signInOtp({
        otp,
        accessCode: getAccessCode() || 0,
        failure: (error) => {
          if (
            error.code === "blocked_international_signin" ||
            error.code === "request_parent_agreement" ||
            error.code === "withdrawal_grace_period" ||
            error.code === "protected_by_nass"
          ) {
            handleRedirectFailure(error, { setErrorCode, accesscode: getAccessCode() });
          }
          setErrorCode(error.code);
          setButtonLoading(false);
        },
        redirectUrl: getRedirectUrl(),
        fallbackUrl: getFallbackUrl(),
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return { signInOtp, errorCode };
};

export default useOneTimeLogin;
